import type React from "react";
import useStepEmailController from "./hooks/useStepEmailController";
import { usePublicIntegrationFlags } from "./hooks/usePublicIntegrationFlags";
import { useStepEmailSiteTexts, type StepEmailOuterProps } from "./hooks/useStepEmailSiteTexts";
import StepEmailPanelsContent from "./components/StepEmailPanelsContent";
import { computeStepEmailProAuthUiFlags } from "./stepEmailProAuthUiVisibility";

export default function StepEmailPanels(props: StepEmailOuterProps): React.JSX.Element {
	const { onSubmit, validationErrors } = props;
	const controller = useStepEmailController();
	const siteTexts = useStepEmailSiteTexts();
	const { ready, flags, public_ui } = usePublicIntegrationFlags();
	const { showIdNotNotaryBlock } = computeStepEmailProAuthUiFlags({
		ready,
		flags,
		login_show_idnot_notary_connection: public_ui.login_show_idnot_notary_connection,
	});

	return (
		<StepEmailPanelsContent
			siteTexts={siteTexts}
			showIdNotNotaryBlock={showIdNotNotaryBlock}
			onNotaryConnect={controller.redirectUserOnConnection}
			onSubmit={onSubmit}
			validationErrors={validationErrors}
			prefilledEmail={controller.prefilledEmail}
		/>
	);
}
